export const colors = [
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
  '#f8c102',
  '#f79533',
  '#f37055',
  '#fe6083',
  '#ef4e7b',
  '#a166ab',
  '#b469fa',
  '#655de6',
  '#5073b8',
  '#1098ad',
  '#07b39b',
  '#6fba82',
];
